var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9999 7.19999C8.63642 7.19999 9.24687 6.94714 9.69696 6.49705C10.147 6.04696 10.3999 5.43651 10.3999 4.79999C10.3999 4.16347 10.147 3.55303 9.69696 3.10294C9.24687 2.65285 8.63642 2.39999 7.9999 2.39999C7.36338 2.39999 6.75293 2.65285 6.30285 3.10294C5.85276 3.55303 5.5999 4.16347 5.5999 4.79999C5.5999 5.43651 5.85276 6.04696 6.30285 6.49705C6.75293 6.94714 7.36338 7.19999 7.9999 7.19999ZM2.3999 14.4C2.3999 13.6646 2.54475 12.9364 2.82618 12.257C3.1076 11.5775 3.5201 10.9602 4.0401 10.4402C4.56011 9.92019 5.17745 9.5077 5.85688 9.22627C6.5363 8.94484 7.2645 8.79999 7.9999 8.79999C8.7353 8.79999 9.46351 8.94484 10.1429 9.22627C10.8224 9.5077 11.4397 9.92019 11.9597 10.4402C12.4797 10.9602 12.8922 11.5775 13.1736 12.257C13.4551 12.9364 13.5999 13.6646 13.5999 14.4H2.3999Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.0eb12c1d7fe51e582a3babc3c33779aa.svg";
export { ForwardRef as ReactComponent };